module.exports = __webpack_public_path__ + "img/Structures-3-mobile.3d4aea53.png";